import React from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel, Switch as MuiSwitch } from '@mui/material_modern'
import { Controller } from 'react-hook-form'

const Switch = ({
  name,
  label,
  control,
  disabled,
  onChange: onChangeProp,
  defaultValue,
  labelPlacement,
  sx,
  ...restProps
}) => (
  <FormControlLabel
    sx={sx}
    control={
      <Controller
        name={name}
        control={control}
        disabled={disabled}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => (
          <MuiSwitch
            checked={value || false}
            defaultValue={defaultValue}
            onChange={e => {
              onChange(e.target.checked)
              onChangeProp(e.target.checked)
            }}
            disabled={disabled}
            {...restProps}
          />
        )}
      />
    }
    label={label}
    labelPlacement={labelPlacement}
  />
)

Switch.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.bool,
  control: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  labelPlacement: PropTypes.oneOf(['top', 'start', 'bottom', 'end']),
  sx: PropTypes.object,
}

Switch.defaultProps = {
  defaultValue: false,
  disabled: false,
  onChange: () => {},
  labelPlacement: 'end',
}

export default Switch
